import React from 'react';
import PropTypes from 'prop-types';

export default function WeatherIcon({ size, color, ...rest }) {
  return (
    <svg {...rest} fill={color} width={size} height={size} viewBox="0 0 26 26">
      <path d="M13,-1.59872116e-14 C20.1765959,0.00749253713 25.9925075,5.82340405 26,13 C26,20.1797017 20.1797017,26 13,26 C5.82029825,26 6.39488462e-14,20.1797017 6.39488462e-14,13 C6.39488462e-14,5.82029825 5.82029825,-1.59872116e-14 13,-1.59872116e-14 Z M17.4546806,2.24544972 C13.104871,0.443699614 8.09802367,1.43962348 4.76882357,4.76882357 C1.43962348,8.09802367 0.443699614,13.104871 2.24544972,17.4546806 C4.04719983,21.8044901 8.29180007,24.6406413 13,24.6406413 C19.4258433,24.6331505 24.6331505,19.4258433 24.6406413,13 C24.6406413,8.29180007 21.8044901,4.04719983 17.4546806,2.24544972 Z M8.46503523,11.5752796 L8.46503523,19.071802 L6.71976298,19.071802 L6.71976298,11.5752796 L8.46503523,11.5752796 Z M12.2332255,6.02195887 L12.2332255,19.071802 L10.4879533,19.071802 L10.4879533,6.02195887 L12.2332255,6.02195887 Z M16.0014158,9.16239395 L16.0014158,19.071802 L14.2561436,19.071802 L14.2561436,9.16239395 L16.0014158,9.16239395 Z M19.7696061,14.6328293 L19.7696061,19.071802 L18.0243339,19.071802 L18.0243339,14.6328293 L19.7696061,14.6328293 Z" />
    </svg>
  );
}

WeatherIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

WeatherIcon.defaultProps = {
  size: 15,
  color: '#000',
};
